{
  "version": 1,
  "asset_id": "67e93c2d-522d-44df-b0ab-5f668819061f",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/67e93c2d-522d-44df-b0ab-5f668819061f/g16.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/67e93c2d-522d-44df-b0ab-5f668819061f/g16.jpg",
  "original_filename": "g16.jpg",
  "size": 2178452,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T22:52:58Z"
}
